export default __webpack_public_path__ + "dea831b8d9df13c9a68f120fe9373ba1.jpg";